import { images } from './images';

export const postCategories = ['Tous', 'Achats', 'Supply chain', 'Négociation', 'Organisation'];

export const posts = [
  {
    slug: 'reduire-couts-achats-sans-degrader-qualite',
    category: 'Achats',
    title: 'Réduire ses coûts d’achats sans dégrader la qualité : 5 leviers concrets',
    excerpt:
      'Baisser les prix n’est qu’un levier parmi d’autres. Spécification, volumes, coût complet : tour d’horizon des leviers qui font vraiment la différence.',
    date: '14 octobre 2026',
    readTime: '7 min',
    image: images.meeting,
    content: [
      { type: 'p', text: 'Quand une direction générale demande de « baisser les achats de 10 % », le réflexe est souvent de se tourner vers les fournisseurs pour obtenir une remise. C’est un levier, mais rarement le plus puissant ni le plus durable.' },
      { type: 'h2', text: '1. Revoir le besoin avant le prix' },
      { type: 'p', text: 'Une spécification trop exigeante, un emballage surdimensionné, une fréquence de livraison inutile : le juste besoin représente souvent 30 à 40 % des gains d’un projet achats.' },
      { type: 'h2', text: '2. Raisonner en coût complet' },
      { type: 'p', text: 'Le prix unitaire ne dit rien des coûts de transport, de stockage, de non-qualité ou de gestion administrative. Le coût total de possession (TCO) permet de comparer des offres réellement comparables.' },
      { type: 'h2', text: '3. Regrouper et mettre en concurrence' },
      { type: 'p', text: 'Consolider les volumes entre sites ou filiales et relancer une consultation structurée reste un levier efficace, à condition de préparer soigneusement le cahier des charges.' },
      { type: 'p', text: 'Enfin, gardez en tête que les gains doivent être suivis dans le temps : un tableau de bord simple, partagé avec la finance, évite que les économies négociées ne s’évaporent.' },
    ],
  },
  {
    slug: 'stocks-dormants-bfr',
    category: 'Supply chain',
    title: 'Stocks dormants : comment libérer votre trésorerie en 90 jours',
    excerpt:
      'Les stocks à faible rotation pèsent lourd sur le BFR. Voici une méthode en trois temps pour les identifier, les écouler et éviter qu’ils ne se reforment.',
    date: '2 octobre 2026',
    readTime: '6 min',
    image: images.warehouse,
    content: [
      { type: 'p', text: 'Dans la plupart des entreprises que j’accompagne, 15 à 30 % du stock n’a pas bougé depuis plus de six mois. C’est de la trésorerie immobilisée, de la place perdue et un risque d’obsolescence.' },
      { type: 'h2', text: 'Identifier : la segmentation ABC/XYZ' },
      { type: 'p', text: 'Croiser la valeur consommée et la régularité de la demande permet de repérer les références à surveiller en priorité et d’adapter les règles de réapprovisionnement à chaque segment.' },
      { type: 'h2', text: 'Écouler : un plan d’actions par famille' },
      { type: 'p', text: 'Retour fournisseur, déstockage, réutilisation interne ou dépréciation : chaque famille appelle une décision claire, prise avec la finance et le commerce.' },
      { type: 'h2', text: 'Prévenir : des paramètres revus régulièrement' },
      { type: 'p', text: 'Stocks de sécurité, quantités minimales de commande, délais : des paramètres figés il y a cinq ans sont la première cause de surstock. Une revue trimestrielle suffit souvent.' },
    ],
  },
  {
    slug: 'preparer-negociation-fournisseur',
    category: 'Négociation',
    title: 'Préparer une négociation fournisseur : la check-list de 20 ans de terrain',
    excerpt:
      'Une négociation se gagne avant d’entrer dans la salle. Objectifs, marges de manœuvre, alternatives : la préparation qui change tout.',
    date: '18 septembre 2026',
    readTime: '8 min',
    image: images.meeting,
    content: [
      { type: 'p', text: 'En vingt ans, j’ai mené des centaines de négociations. Les meilleures n’étaient pas celles où j’étais la plus habile, mais celles où j’étais la mieux préparée.' },
      { type: 'h2', text: 'Connaître sa meilleure alternative' },
      { type: 'p', text: 'Sans solution de repli crédible, il n’y a pas de négociation, seulement une demande. Identifier un fournisseur alternatif, même imparfait, change le rapport de force.' },
      { type: 'h2', text: 'Comprendre les contraintes du fournisseur' },
      { type: 'p', text: 'Capacités, saisonnalité, structure de coûts : plus vous comprenez votre fournisseur, plus vous trouverez des contreparties qui ne coûtent rien à l’un et valent beaucoup pour l’autre.' },
      { type: 'p', text: 'Enfin, fixez un objectif ambitieux, un seuil de rupture et une liste de concessions possibles, classées par ordre de valeur. Et répartissez les rôles si vous négociez à plusieurs.' },
    ],
  },
  {
    slug: 'structurer-fonction-achats-pme',
    category: 'Organisation',
    title: 'PME : quand et comment structurer sa fonction achats ?',
    excerpt:
      'À partir de quel niveau de dépenses faut-il un acheteur ? Quelle organisation choisir ? Retour d’expérience sur les étapes clés.',
    date: '4 septembre 2026',
    readTime: '5 min',
    image: images.hero,
    content: [
      { type: 'p', text: 'Dans une PME, les achats sont souvent répartis entre la direction, la production et la comptabilité. Cela fonctionne… jusqu’au jour où les dépenses dépassent quelques millions d’euros.' },
      { type: 'h2', text: 'Les signaux qui ne trompent pas' },
      { type: 'p', text: 'Des fournisseurs choisis par habitude, des contrats introuvables, des factures qui surprennent : ce sont les signes qu’une fonction achats structurée créerait rapidement de la valeur.' },
      { type: 'h2', text: 'Commencer simplement' },
      { type: 'p', text: 'Une cartographie des dépenses, une politique achats d’une page, un processus de validation clair et un premier acheteur bien positionné suffisent souvent à générer des gains significatifs dès la première année.' },
    ],
  },
  {
    slug: 'risques-fournisseurs-resilience',
    category: 'Supply chain',
    title: 'Risques fournisseurs : bâtir une supply chain résiliente',
    excerpt:
      'Pénuries, défaillances, tensions géopolitiques : comment cartographier vos risques fournisseurs et préparer des plans de continuité réalistes.',
    date: '21 août 2026',
    readTime: '6 min',
    image: images.port,
    content: [
      { type: 'p', text: 'Les crises récentes ont rappelé une évidence : une supply chain optimisée uniquement sur le coût est une supply chain fragile.' },
      { type: 'h2', text: 'Cartographier les dépendances' },
      { type: 'p', text: 'Fournisseurs uniques, zones géographiques concentrées, santé financière : une matrice probabilité × impact permet de prioriser les risques à traiter.' },
      { type: 'h2', text: 'Des plans de continuité proportionnés' },
      { type: 'p', text: 'Double sourcing, stocks de sécurité ciblés, clauses contractuelles : chaque risque majeur doit avoir une réponse préparée, et testée.' },
    ],
  },
  {
    slug: 'indicateurs-performance-achats',
    category: 'Achats',
    title: 'Les 6 indicateurs qui suffisent pour piloter vos achats',
    excerpt:
      'Inutile de suivre 40 KPI. Six indicateurs bien choisis donnent une vision claire de la performance achats et parlent à la direction.',
    date: '7 août 2026',
    readTime: '4 min',
    image: images.warehouse,
    content: [
      { type: 'p', text: 'Un bon tableau de bord achats tient sur une page et se lit en deux minutes. Voici les six indicateurs que je mets en place dans la plupart de mes missions.' },
      { type: 'h2', text: 'Gains, couverture, performance' },
      { type: 'p', text: 'Gains achats validés par la finance, part des dépenses sous contrat, taux de service fournisseurs, délai de traitement des commandes, nombre de fournisseurs actifs et part des fournisseurs à risque.' },
      { type: 'p', text: 'L’essentiel n’est pas l’indicateur lui-même, mais le rituel de revue qui l’accompagne et les décisions qu’il déclenche.' },
    ],
  },
];
